/**
 * iurop-quick-add.js — Añadir al carrito desde fuera del drawer (MORAY).
 * Cualquier [data-quick-add="<variant_id>"] (upsells de PDP/sidecart) añade
 * 1 ud. por /cart/add.js y dispara `cart:updated` con detail:{cart} →
 * iurop-cart-drawer.js re-pinta el sidecart y lo abre. Sin JS, navega al href.
 */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(btn.getAttribute('data-quick-add')), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/add failed');
        return res.json();
      })
      .then(function () {
        // Contrato §5: detail.cart = carrito COMPLETO (add.js solo devuelve
        // la línea añadida). Los receptores toleran cart null (fallback).
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function () {
        var href = btn.getAttribute('href');
        if (href) window.location.href = href;
      })
      .then(function () {
        btn.classList.remove('is-loading');
      });
  });
})();
